<script>
	import { slugify } from "cando-util";
	import { updatePdfUrl } from "./updatePdfUrl";

	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faCircleMinus } from "@fortawesome/free-solid-svg-icons";

	import Textarea from "$lib/components/Textarea.svelte";
	import Select from "$lib/components/Select.svelte";

	export let value;
	export let documentValues = {};
	export let documents = [];
	export let tags;
	export let label;
	export let question = null;
	export let handleChange = () => {};

	let newField;

	const getOptions = (fields, values) => {
		const unusedFields = fields.filter((f) => values[f] === undefined);
		const options = [];
		const checkFields = { "PAYMENT #": null, "DATE #": null };
		for (const field of unusedFields) {
			const checkField = Object.keys(checkFields).filter((k) =>
				field.startsWith(k),
			)[0];
			if (!checkField) {
				options.push(field);
			} else {
				if (checkFields[checkField] === null) {
					const nextAvailableField = unusedFields
						.filter((f) => f.startsWith(checkField))
						.sort()[0];
					if (nextAvailableField) {
						options.push(nextAvailableField);
						checkFields[checkField] = nextAvailableField;
					}
				}
			}
		}
		return options;
	};

	$: documentFields = (tags || "").split("-|-"); // includes an empty for the dropdown
	$: options = getOptions(documentFields, documentValues);
	$: allCurrentValues = [
		...documentFields
			.filter((f) => !!f)
			.filter((f) => documentValues[f] !== undefined),
		...Object.keys(documentValues || {}).filter(
			(f) => !documentFields.includes(f),
		),
	];

	const handleFieldChange = async (e) => {
		const field =
			e.target.getAttribute("key") ||
			e.target.closest("button").getAttribute("key");
		const files = Object.entries(value).filter(
			([k, v]) => v.type !== undefined,
		);

		for (const [key, file] of files) {
			if (file.tags.split("-|-").includes(field)) {
				const { hash, dataUrl } = await updatePdfUrl(
					file,
					documentValues,
				);
				value[key].dataUrl = dataUrl;
				value[key].hash = hash;
			}
		}

		if (question) {
			handleChange(question);
		}
	};

	const handleNewFieldSelect = (e) => {
		if (!newField) return;
		documentValues[newField] = "";
		newField = "";
		handleChange(question);
	};
</script>

<div class="grid grid-cols-[auto_1fr] gap-x-4 gap-y-6">
	{#each allCurrentValues as field}
		<div class="font-medium">
			<div>
				{field.replace(/_/g, " ")}
			</div>
			<div>
				Occurances: {documents
					.map((d) => (d?.fieldLocations?.[field] || []).length)
					.reduce((a, v) => a + v, 0)}
			</div>
		</div>
		<div class="flex">
			<div class="w-full">
				<Textarea
					bind:value={documentValues[field]}
					label={field}
					key={field}
					handleChange={handleFieldChange}
					keepTab={false}
				/>
			</div>
			<div class="ml-2 sm:ml-4">
				<button
					id={`delete-${slugify(field)}-button`}
					class="text-error"
					key={field}
					on:click|preventDefault={(e) => {
						delete documentValues[field];
						documentValues = { ...documentValues };
						handleFieldChange(e);
					}}
				>
					<SvelteFa icon={faCircleMinus} size="1.5x" />
				</button>
			</div>
		</div>
	{/each}
</div>

{#if documentFields.length > 1}
	<div class="flex justify-between mt-4 w-full">
		<div class="lg:flex lg:gap-4 w-full">
			<div class=" text-nowrap">Add Field:</div>
			<div class="w-full">
				<Select
					name={`${label} new field select`}
					{options}
					bind:value={newField}
					handleChange={handleNewFieldSelect}
				/>
			</div>
		</div>
	</div>
{/if}
